// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tools_container__Htxf\\+ {
  max-width: 500px;
  margin: 40px auto;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.Tools_form__Z7kfP {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.Tools_input__F07Ds {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
.Tools_button__KAKFG {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.Tools_button__KAKFG:hover {
  background: #1565c0;
}
.Tools_imageUploadBlock__7xCIq {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 8px 0;
}
.Tools_addImageButton__zE\\+LK {
  background: #fff;
  color: #1976d2;
  border: 1px solid #1976d2;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.Tools_addImageButton__zE\\+LK:disabled {
  color: #aaa;
  border-color: #ccc;
  cursor: not-allowed;
  background: #f5f5f5;
}
.Tools_addImageButton__zE\\+LK:not(:disabled):hover {
  background: #1976d2;
  color: #fff;
}
.Tools_imagePreviewArea__OTym1 {
  display: flex;
  gap: 12px;
  margin: 8px 0 8px 0;
}
.Tools_imagePreviewWrapper__mV-0r {
  position: relative;
  display: inline-block;
}
.Tools_imagePreview__LRV88 {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #f8f8f8;
}
.Tools_deleteImageButton__dOrKY {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background 0.2s;
}
.Tools_deleteImageButton__dOrKY:hover {
  background: #d32f2f;
}
.Tools_toolName__6e8Yv {
  font-weight: bold;
  margin-bottom: 4px;
}
.Tools_toolImageList__3I-d6 {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}
.Tools_toolImage__4J03g {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #f8f8f8;
}
.Tools_toolList__Uxmms {
  list-style: none;
  padding: 0;
  margin: 0;
}
.Tools_toolItem__50vh- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
.Tools_deleteButton__K3hxO {
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
}
.Tools_deleteButton__K3hxO:hover {
  background: #b71c1c;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Tools/Tools.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".container {\r\n  max-width: 500px;\r\n  margin: 40px auto;\r\n  padding: 24px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n}\r\n.form {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n.input {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n}\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n.imageUploadBlock {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin: 8px 0 8px 0;\r\n}\r\n.addImageButton {\r\n  background: #fff;\r\n  color: #1976d2;\r\n  border: 1px solid #1976d2;\r\n  border-radius: 4px;\r\n  padding: 6px 16px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n.addImageButton:disabled {\r\n  color: #aaa;\r\n  border-color: #ccc;\r\n  cursor: not-allowed;\r\n  background: #f5f5f5;\r\n}\r\n.addImageButton:not(:disabled):hover {\r\n  background: #1976d2;\r\n  color: #fff;\r\n}\r\n.imagePreviewArea {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin: 8px 0 8px 0;\r\n}\r\n.imagePreviewWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.imagePreview {\r\n  width: 80px;\r\n  height: 80px;\r\n  object-fit: cover;\r\n  border-radius: 6px;\r\n  border: 1px solid #ccc;\r\n  background: #f8f8f8;\r\n}\r\n.deleteImageButton {\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 2px;\r\n  background: rgba(0,0,0,0.6);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2;\r\n  transition: background 0.2s;\r\n}\r\n.deleteImageButton:hover {\r\n  background: #d32f2f;\r\n}\r\n.toolName {\r\n  font-weight: bold;\r\n  margin-bottom: 4px;\r\n}\r\n.toolImageList {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n}\r\n.toolImage {\r\n  width: 60px;\r\n  height: 60px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n  background: #f8f8f8;\r\n}\r\n.toolList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.toolItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n.deleteButton {\r\n  background: #d32f2f;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 4px 10px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.deleteButton:hover {\r\n  background: #b71c1c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tools_container__Htxf+`,
	"form": `Tools_form__Z7kfP`,
	"input": `Tools_input__F07Ds`,
	"button": `Tools_button__KAKFG`,
	"imageUploadBlock": `Tools_imageUploadBlock__7xCIq`,
	"addImageButton": `Tools_addImageButton__zE+LK`,
	"imagePreviewArea": `Tools_imagePreviewArea__OTym1`,
	"imagePreviewWrapper": `Tools_imagePreviewWrapper__mV-0r`,
	"imagePreview": `Tools_imagePreview__LRV88`,
	"deleteImageButton": `Tools_deleteImageButton__dOrKY`,
	"toolName": `Tools_toolName__6e8Yv`,
	"toolImageList": `Tools_toolImageList__3I-d6`,
	"toolImage": `Tools_toolImage__4J03g`,
	"toolList": `Tools_toolList__Uxmms`,
	"toolItem": `Tools_toolItem__50vh-`,
	"deleteButton": `Tools_deleteButton__K3hxO`
};
export default ___CSS_LOADER_EXPORT___;
